export function setPuppyInventoryStatus(action, state) {
  const { inventoryStatusId } = action;
  const newState = { ...state };
  newState.data.puppy.inventoryStatusId = Number(inventoryStatusId);
  return newState;
}
